/** Shared stacking order for floating map windows (image viewers, SLP, SDM). */
let maxWindowZIndex = 25;

export function getNextWindowZIndex(): number {
  maxWindowZIndex += 1;
  return maxWindowZIndex;
}

/** Resets the counter, for unit tests only. */
export function resetWindowZIndexForTests(value = 25): void {
  maxWindowZIndex = value;
}
